import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';

const Hero = () => {
  const heroImage = require('../img/hero10.jpg');
  const { language } = useContext(LanguageContext);

  const content = {
    fr: {
      title: 'Omra inoubliable alliant spiritualité et sérénité',
      description:
        'Un voyage organisé avec soins pour une expérience unique à la Mecque et Médine. Réservez votre Omra de rêve dès maintenant.',
      button: 'Voir nos offres',
    },
    ar: {
      title: 'عمرة لا تُنسى تجمع بين الروحانيات والصفاء',
      description:
        'رحلة منظمة بعناية لتجربة فريدة في مكة والمدينة. احجز عمرة أحلامك الآن.',
      button: 'عرض العروض',
    },
  };

  return (
    <section className="relative min-h-screen flex flex-col justify-center items-center text-white overflow-hidden pt-32">
      {/* Image de fond */}
      <img
        src={heroImage}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover object-top brightness-110 contrast-105"
      />

     
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>

     
      <div className="container mx-auto px-6 relative z-10 flex flex-col h-full text-center">
        <div className="flex items-center justify-center flex-grow">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              {content[language].title}
            </h1>
            <p className="text-base md:text-lg mb-6 max-w-2xl mx-auto">
              {content[language].description}
            </p>
          </div>
        </div>

       
        <div className="mt-1 z-20">
          <a
            href="#offres"
            className="bg-transparent border-2 border-green-500 text-green-500 font-semibold py-2 px-6 rounded-full text-base shadow-md hover:bg-green-500 hover:text-white hover:border-green-600 hover:shadow-lg transition-all duration-300"
          >
            {content[language].button}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
